module.exports = __webpack_public_path__ + "static/media/kdkLogo.0c8a3c3d.png";